import { GAME_WIDTH, GAME_HEIGHT } from '../config/gameConfig.js';

/**
 * Layered vessel interior: maroon plasma, drifting RBC silhouettes, tissue walls (matches example.png mood).
 * @param {Phaser.Scene} scene
 */
export function buildBloodstreamBackdrop(scene) {
  const base = scene.add.graphics().setDepth(-125);
  base.fillGradientStyle(0x4a1620, 0x2c0c14, 0x140608, 0x080204, 1);
  base.fillRect(0, 0, GAME_WIDTH, GAME_HEIGHT);

  const silhouettes = scene.add.graphics().setDepth(-124);
  silhouettes.fillStyle(0x98566a, 0.1);
  for (let i = 0; i < 52; i++) {
    const sx = ((i * 131) % (GAME_WIDTH + 100)) - 50;
    const sy = ((i * 79) % (GAME_HEIGHT + 20)) - 10;
    const w = 16 + (i % 6) * 3;
    const h = 8 + (i % 4) * 2;
    silhouettes.fillEllipse(sx, sy, w, h);
  }

  const flowSheets = scene.add.graphics().setDepth(-123);
  for (let b = 0; b < 16; b++) {
    flowSheets.fillStyle(0x1a040c, 0.05 + (b % 4) * 0.028);
    flowSheets.fillRect(0, b * (GAME_HEIGHT / 16), GAME_WIDTH, 20);
  }

  const flowLines = scene.add.graphics().setDepth(-123);
  flowLines.lineStyle(1.5, 0x321018, 0.12);
  for (let row = 0; row < 5; row++) {
    flowLines.beginPath();
    const y0 = 70 + row * 110;
    flowLines.moveTo(0, y0);
    for (let x = 0; x <= GAME_WIDTH; x += 12) {
      flowLines.lineTo(x, y0 + Math.sin(x * 0.045 + row * 1.7) * 7);
    }
    flowLines.strokePath();
  }

  const wallTop = scene.add.graphics().setDepth(-122);
  wallTop.fillStyle(0xb86886, 1);
  for (let x = -44; x < GAME_WIDTH + 60; x += 18) {
    const bump = Math.sin(x * 0.105) * 11 + Math.sin(x * 0.185 + 2.1) * 8;
    wallTop.fillCircle(x + 11, 26 + bump, 21 + ((x + 260) % 9) * 0.35);
  }
  wallTop.fillStyle(0x884468, 0.92);
  for (let x = -36; x < GAME_WIDTH + 55; x += 22) {
    const bump = Math.sin(x * 0.125 + 0.8) * 9;
    wallTop.fillCircle(x + 5, 17 + bump, 15);
  }

  const wallBot = scene.add.graphics().setDepth(-122);
  wallBot.fillStyle(0xa06078, 1);
  for (let x = -42; x < GAME_WIDTH + 60; x += 18) {
    const bump = Math.sin(x * 0.098 + 3.4) * 12 + Math.sin(x * 0.162) * 7;
    wallBot.fillCircle(x + 13, GAME_HEIGHT - 28 - bump, 22 + ((x + 180) % 10) * 0.35);
  }
  wallBot.fillStyle(0x704058, 0.9);
  for (let x = -38; x < GAME_WIDTH + 55; x += 21) {
    const bump = Math.sin(x * 0.118 + 2.2) * 8;
    wallBot.fillCircle(x + 6, GAME_HEIGHT - 18 - bump, 16);
  }

  return [base, silhouettes, flowSheets, flowLines, wallTop, wallBot];
}
